export class Popup {
    constructor(popupSelector) {
        this._popup = document.querySelector(popupSelector);
    }

    open() {
        this._popup.classList.add('popup_opened');
        document.addEventListener('keyup', this._handleEscClose);
    }

    close() {
        this._popup.classList.remove('popup_opened');
        document.removeEventListener('keyup', this._handleEscClose);
    }

    _handleEscClose = (event) => {
        if(event.key === 'Escape') {
            this.close();
        };
    }

    setEventListeners() {
        this._popup.addEventListener('click', event => {
            if(event.target.classList.contains('popup_opened') || event.target.classList.contains('popup__close-btn')) {
                this.close();
            }
        });
    }
}